import { urlBase64ToUint8Array } from '../utils/urlBaseToUnit'
const STORAGE_KEY = "pushy_subscription_v22"

const toB64url = (buf) =>
  buf
    ? btoa(String.fromCharCode(...new Uint8Array(buf)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "")
    : ""

const pushyService = {
  async register(sendDeviceToken) {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      throw new Error("Push уведомления не поддерживаются")
    }

    const reg = await navigator.serviceWorker.ready
    const vapid = process.env.REACT_APP_VAPID_PUBLIC_KEY
    const vapidId = "v1"
    const appName = process.env.REACT_APP_PROJECT_NAME || ""
    const base = process.env.REACT_APP_PUSHY_URI

    let saved = null
    try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null") } catch {}

    let sub = await reg.pushManager.getSubscription()
    let needNewSub = false

    if (sub) {
      try {
        const p = sub.getKey("p256dh")
        const a = sub.getKey("auth")
        if (!p || !a || a.byteLength !== 16) needNewSub = true
      } catch { needNewSub = true }
    } else {
      needNewSub = true
    }

    if (needNewSub && sub) {
      try { await sub.unsubscribe() } catch {}
      sub = null
    }
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapid)
      })
    }

    const p256dh = toB64url(sub.getKey("p256dh"))
    const akey = toB64url(sub.getKey("auth"))

    const authResp = await fetch(`${base}/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        platform: "web",
        app: appName,
        origin: window.location.origin,
        vapidPublicKeyId: vapidId,
        subscription: {
          endpoint: sub.endpoint,
          keys: { p256dh, auth: akey },
          expirationTime: sub.expirationTime
        }
      })
    })
    if (!authResp.ok) throw new Error(`Auth upsert failed: ${authResp.status}`)

    const result = await authResp.json()

    const toSave = {
      endpoint: sub.endpoint,
      token: result.token,
      auth: result.auth,
      vapid,
      p256dh,
      akey
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave))

    await sendDeviceToken({ token: result.token, auth: result.auth })
    return result.token
  }
}

export default pushyService
